module.exports = __webpack_public_path__ + "img/xiangkuang.c7e1afb3.png";